import {IMqttMessage, MqttService} from 'ngx-mqtt';
import {asyncScheduler, Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getAuth} from '~feature/feature-auth/feature-auth.selectors';
import {observeOn} from 'rxjs/operators';
import {environment} from '~env/environment';
import {AbstractMqttService} from '~core/api/mqtt/abstract-mqtt.service';

export class EventMqttService extends AbstractMqttService {

  private readonly endpoint: string;
  private subs: { [key: string]: Subscription } = {};

  constructor(
    private store: Store,
    private _mqttService?: MqttService
  ) {
    super();
    this.endpoint = environment.mqtt?.defaultEndpoint ?? '';
  }

  subscribe(topic: string, next?: (value: IMqttMessage) => void, error?: (error: unknown) => void, complete?: () => void)
    : Subscription {
    const topicName = `${topic.replace(/\./g, '/')}`;

    if (!this.isSubscribed(topic)) {
      const subscription = this._mqttService?.observe(topicName).subscribe(next, error, complete);
      if (subscription) {
        this.subs[topicName] = subscription;
      }
    }

    return this.subs[topicName];
  }

  unsubscribe(topic: string): void {
    const topicName = `${topic.replace(/\./g, '/')}`;

    if (this.subs[topicName]) {
      this.subs[topicName].unsubscribe();
    }
  }

  isSubscribed(topic: string): boolean {
    const topicName = `${topic.replace(/\./g, '/')}`;

    return !!this.subs[topicName];
  }

  inicializar(): void {
    this.store.pipe(select(getAuth))
      .pipe(observeOn(asyncScheduler))
      .subscribe((auth) => {
        if (auth && auth.token && auth.roles?.includes('Operador') && this.endpoint.length) {
          const user = `${auth.empresa ?? '?'}@${auth.nickname ?? 'anonymous'}`;
          const topic = `${(this.endpoint ?? '')}:${user}`;
          if (this.subs[topic]) {
            return;
          }
          this.subscribe(topic,
            data => {
              const item = JSON.parse(data.payload.toString());
              console.log('mqtt', item);
            },
            error => console.error('[mqtt]', error));
        } else {
          Object.keys(this.subs).forEach(key => this.subs[key]?.unsubscribe());
          this.subs = {};
          this._mqttService?.disconnect();
        }
      });
  }
}
